import React from "react";
import "./mainDashboard.css"
export const CustomSkeleton = () => {
    return (
        <div style={{ paddingBottom: "8px" }}>
        <div style={{ display: "flex", gap: "1rem", marginTop: "0.5rem" }}>
          <div className="skeleton" style={{ width: "50%", height: "220px" }} />
          <div className="skeleton" style={{ width: "50%", height: "220px" }} />
        </div>
  
        <div style={{ display: "flex", gap: "1rem", marginTop: "1rem" }}>
          <div className="skeleton" style={{ width: "68%", height: "190px" }} />
          <div className="skeleton" style={{ width: "32%", height: "190px" }} />
        </div>
  
        <div style={{ display: "flex", gap: "1rem", marginTop: "1rem" }}>
          <div className="skeleton" style={{ width: "38%", height: "210px" }} />
          <div className="skeleton" style={{ width: "62%", height: "210px" }} />
        </div>
  
        <div style={{ marginTop: "1rem" }}>
          <div className="skeleton" style={{ width: "100%", height: "180px" }} />
        </div>
      </div>
    );
  };
